import { render, staticRenderFns } from "./TenancyRecordTNC.vue?vue&type=template&id=f92e0b8a&scoped=true&"
import script from "./TenancyRecordTNC.vue?vue&type=script&lang=js&"
export * from "./TenancyRecordTNC.vue?vue&type=script&lang=js&"
import style0 from "./TenancyRecordTNC.vue?vue&type=style&index=0&id=f92e0b8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f92e0b8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f92e0b8a')) {
      api.createRecord('f92e0b8a', component.options)
    } else {
      api.reload('f92e0b8a', component.options)
    }
    module.hot.accept("./TenancyRecordTNC.vue?vue&type=template&id=f92e0b8a&scoped=true&", function () {
      api.rerender('f92e0b8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/settings/engineers/regionConfig/TenancyRecordTNC.vue"
export default component.exports